import React from "react";
import { Row, Col, Modal, Button } from "antd";
import styles from "./Modals.module.scss";
import { useWindowSize } from "../../../hooks/useWindowSize";
import DashBoardTable from "../../DashBoard/DashBoardTable";
import { ITripDetails } from "../../ServiceUsers/Interfaces/ITripDetails";
import moment from "moment";
import CollapsibleTrips from "../CollapsibleTrips/CollapsibleTrips";
type Props = {
  visible: boolean;
  setVisibility: Function;
  trip: ITripDetails[];
};
const TripDetailsModal: React.FC<Props> = ({
  visible,
  setVisibility,
  trip,
}) => {
  const handleClose = () => setVisibility(false);
  const { width } = useWindowSize();
  return (
    <Modal
      visible={visible}
      className={styles.tripDetailsModalContainer}
      centered={width < 992}
      width={width < 992 ? "340px" : "776px"}
      footer={
        <Row justify="center">
          <Col>
            <Button className={styles.modalCloseBtn} onClick={handleClose}>
              Close
            </Button>
          </Col>
        </Row>
      }
    >
      <Row justify="center">
        <Col span={24} className={styles.modalTitle}>
          {trip[0]?.serviceUser}'s trip on
        </Col>
        <Col span={24} className={styles.modalTitle}>
          {moment(moment(trip[0]?.tripDate).format("YYYY-MM-DD")).format(
            "dddd"
          )}
          , {moment(trip[0]?.tripDate).format("MM/DD/YYYY")}
        </Col>
      </Row>
      <Row justify="center" className={styles.modalBody}>
        <Col xs={0} lg={24}>
          <DashBoardTable
            dataSource={trip}
            isCalling="BillingHistory"
            hideNoServiceMessage={true}
            hideDateSort
          />
        </Col>
        <Col xs={24} lg={0}>
          <div className={styles.collapsibleMobileView}>
            <CollapsibleTrips dataSource={trip} />
          </div>
        </Col>
      </Row>
    </Modal>
  );
};
export default TripDetailsModal;
